module.exports = __webpack_public_path__ + "img/DSC_0012.7b56d252.jpg";